/* eslint-disable no-nested-ternary */
import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import AppLoader from 'components/core/AppLoader';
import Avatar from 'components/core/Avatar';
// Color
import { iconPalette } from 'components/core/colors';
// Custom
import AppIcon from 'components/icons/AppIcon';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';

const TableCellInformationItem = ({
  loading, icon, iconColor, customIcon, label, value, gender, withAvatar,
}) => (
  <div className="d-flex align-items-center">
    {loading ? (
      <AppLoader size={24} />
    ) : (
      (icon || customIcon) && (
        <div className="mr-2">
          {withAvatar ? (
            <Avatar
              size={32}
              primary={withAvatar !== 'colorized'}
              backgroundColor={withAvatar === 'colorized' ? iconColor : null}
            >
              {customIcon || <AppIcon id={icon} />}
            </Avatar>
          ) : (
            <div className="pt-1">
              {customIcon ? (
                <div style={{ width: 24, height: 24 }} className="text-center">
                  {customIcon}
                </div>
              ) : <AppIcon id={icon} color={iconColor} />}
            </div>
          )}
        </div>
      )
    )}
    <div className="text-truncate">
      <div className="table-cell-information-label">
        <TruncatedTooltipText>{label || ' '}</TruncatedTooltipText>
      </div>
      <div className="table-cell-information-value">
        <TruncatedTooltipText>
          {value || <LocalizedMessage id="info.unknown" values={{ gender }} />}
        </TruncatedTooltipText>
      </div>
    </div>
  </div>
);

TableCellInformationItem.propTypes = {
  loading: PropTypes.bool,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  customIcon: PropTypes.element,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  gender: PropTypes.oneOf(['male', 'female']),
  withAvatar: PropTypes.oneOf([true, false, 'colorized']),
};

TableCellInformationItem.defaultProps = {
  loading: false,
  icon: null,
  iconColor: iconPalette.base,
  customIcon: null,
  label: null,
  value: null,
  gender: 'male',
  withAvatar: false,
};

module.exports = TableCellInformationItem;



// WEBPACK FOOTER //
// ./components/items/TableCellInformationItem.js